import { atom, useSetAtom } from 'jotai';

type CatalogIframeAtomType = {
  /**
   * whether to display the iFrame
   */
  show: boolean;
  /**
   * design composite id - must be included to open the iFrame
   */
  designCid?: string;
  /**
   * Overrides the default URL for the iFrame,
   * useful for navigating to a specific page
   */
  url?: string;
  /**
   * Filters to apply to the iFramed catalog
   */
  filters?: {
    /**
     * Froducts compatible with selected design
     */
    compatible_type?: string;
    /**
     * Products with minimum N colors
     */
    color_limit?: number;
  };
};

export const catalogIframeAtom = atom<CatalogIframeAtomType>({ show: false });

export const useOpenCatalogIframe = () => {
  const setCatalogIframe = useSetAtom(catalogIframeAtom);

  const openCatalogIframe = ({
    designCid,
    filters,
    url,
  }: Partial<CatalogIframeAtomType>) => {
    setCatalogIframe({
      show: true,
      designCid,
      filters,
      url,
    });
  };

  return openCatalogIframe;
};
